export default __webpack_public_path__ + "static/media/catprofilepicture.bacbe2fc.jpeg";